import { render, staticRenderFns } from "./DataLogList.vue?vue&type=template&id=a49c70d2&scoped=true"
import script from "./DataLogList.vue?vue&type=script&lang=js"
export * from "./DataLogList.vue?vue&type=script&lang=js"
import style0 from "./DataLogList.vue?vue&type=style&index=0&id=a49c70d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49c70d2",
  null
  
)

export default component.exports